import { Typography } from '@mui/material';
import { AutocompleteArrayInput, ChipField, CreateButton, Datagrid, DateField, Filter, FunctionField, List, NumberField, ReferenceArrayField, ReferenceArrayInput, ReferenceInput, SelectArrayInput, SelectInput, SingleFieldList, TextField, useListContext, usePermissions, useRecordContext, useTranslate } from 'react-admin';
import Permission from '../../components/Permission';
import { PERMISSIONS, frequencyChoices } from '../../constants';
import { getChainId } from '../../lib';
import { ReferenceArrayFieldWithLimit } from '../../components';
import { filterToQuery } from '../../utils';

const FuelField = (props: { label: string }) => {
    const record = useRecordContext();
    if (!record) { return null; }

    return (
        <>
            <ReferenceArrayField record={{ ...record, fuelIds: record.fuelIds.slice(0, 4) }} source="fuelIds" reference="fuels" label="">
                <SingleFieldList linkType={false}>
                    <ChipField source="name" />
                </SingleFieldList>
            </ReferenceArrayField>
            {
                record.fuelIds.length > 4 &&
                <Typography variant="subtitle2" sx={{ paddingTop: 1, paddingLeft: 1 }}>mais {record.fuelIds.length - 4} combustíve{record.fuelIds.length - 4 > 1 ? 'is' : 'l'}</Typography>
            }
        </>
    );
};

const ListFilters = () => {
    const translate = useTranslate();
    const { filterValues } = useListContext();

    return (
        <Filter>
            <SelectInput
                label="Status"
                source="isEnabled"
                choices={[{ label: 'Ativos', value: true }, { label: 'Inativos', value: false }]}
                optionText="label"
                optionValue="value"
                emptyText="Todos"
                alwaysOn
            />
            {
                Permission({
                    permission: PERMISSIONS.ADMIN, children:
                        <ReferenceInput
                            reference="chains"
                            source="chainId"
                            style={{ minWidth: 220 }}
                            sort={{ field: 'name', order: 'ASC' }}
                            perPage={9999}
                            alwaysOn
                        >
                            <SelectInput
                                label="Rede"
                                emptyText="Todos"
                                optionText="name" />
                        </ReferenceInput>
                })
            }
            <ReferenceArrayInput
                reference="stations"
                source="placeIds"
                sort={{ field: 'name', order: 'ASC' }}
                perPage={9999}
                filter={filterValues.chainId ? { chainId: filterValues.chainId } : {}}
                alwaysOn
            >
                <AutocompleteArrayInput
                    filterToQuery={filterToQuery}
                    label="Postos"
                    optionText="name"
                    sx={{ minWidth: 220, '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': { minWidth: 50 } }}
                    noOptionsText={translate('ra.input.autocomplete.no_options_text')}
                />
            </ReferenceArrayInput>
            <ReferenceArrayInput
                reference="fuels"
                source="fuelIds"
                style={{ minWidth: 220 }}
                sort={{ field: "name", order: "ASC" }}
                alwaysOn
            >
                <SelectArrayInput label="Combustíveis" optionText="name" />
            </ReferenceArrayInput>
        </Filter>
    );
};

const AdvertisementList = (props) => {

    const chainId = getChainId();

    const filterDefaultValues: any = { isEnabled: true };
    if (chainId) {
        filterDefaultValues.chainId = chainId;
    }

    return (
        <Permission permission={PERMISSIONS.ADVERTISEMENT}>
            <List
                {...props}
                title="Anúncios"
                sort={{ field: 'createdAt', order: 'DESC' }}
                filterDefaultValues={filterDefaultValues}
                filters={<ListFilters />}
                exporter={false}
                actions={<CreateButton />}
            >
                <Datagrid bulkActionButtons={false} rowClick="show">
                    <TextField source="name" label="Nome" />
                    <DateField source="startAt" label="Data de início" showTime textAlign="center" emptyText="--" locales="pt-BR" />
                    <DateField source="endAt" label="Data de fim" showTime textAlign="center" emptyText="--" locales="pt-BR" />
                    <NumberField source="priority" label="Prioridade" textAlign="center" emptyText="--" />
                    <FunctionField
                        render={record => record && record.frequency ? frequencyChoices.find(dt => dt.id === record.frequency)?.name : '--'}
                        label="Frequência"
                        textAlign="center"
                    />
                    <ReferenceArrayFieldWithLimit
                        source="stationIds"
                        reference="stations"
                        link="show"
                        label="Postos"
                        name="posto"
                        permission={PERMISSIONS.LIST_STATION}
                    />
                    <FuelField label="Combustíveis" />
                    <FunctionField
                        render={record => record && record.isEnabled ? "Ativo" : "Inativo"}
                        label="Status"
                        textAlign="center"
                    />
                </Datagrid>
            </List>
        </Permission>
    );
};

export default AdvertisementList;
